import Vue from 'vue';
import Router from 'vue-router';
import { firebase } from '@/firebase';
import store from '@/store';
Vue.use(Router);

/* Layout */
//import Layout from "@/layout/Layout";

/* Router Modules */
import layoutRouter from './modules/layoutRouter';
import authRouter from './modules/authRouter';
import requestDemoRouter from './modules/requestDemoRouter';

/* Router Modules */
/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:"router-name"             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ["admin","editor"]    control the page roles (you can set multiple roles)
    title: "title"               the name show in sidebar and breadcrumb (recommend set)
    icon: "svg-name"/"el-icon-x" the icon show in the sidebar
    noCache: true                if set true, the page will no be cached(default is false)
    affix: true                  if set true, the tag will affix in the tags-view
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: "/example/list"  if set path, the sidebar will highlight the path you set
  }
 */

/**
 * @constant
 * @name publicRoutes
 * @description A base page that does not have permission requirements all roles can be accessed
 * @type {Array}
 * 
 */

//const publicRoutes = [];

/**
 * @constant
 * @name privateRoutes
 * @description A base page for authenticated and authorized system administrators (roles)
 * @type {Array}
 * 
 */

//const privateRoutes = [];

 /**
 * @constant
 * @name sysAdminRouter
 * @description a base page for authenticated and authorized system administrators (roles)
 * @type {Array}
 * 
 */

//const sysAdminRouter = [];

const routes = [
  {
    path: '/redirect',
    hidden: true,
    children: [
      {
        path: '/redirect/:path(.*)',
        component: () => import('@/views/redirect/index')
      }
    ]
  },
  {
    path: '/404',
    component: () => import('@/views/error-page/404'),
    hidden: true
  },
  {
    path: '/401',
    component: () => import('@/views/error-page/401'),
    hidden: true
  },
  {
    path: '/',
    name: 'Home',
    alias: '/home',
    component: () => import('@/views/Home')
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  /** when your routing map is too long, you can split it into small modules **/
  authRouter,
  requestDemoRouter,
  layoutRouter,

  // 404 page must be placed at the end !!!
  { path: '*', redirect: '/404', hidden: true }
];

/* const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
}); */

/**
 * @function
 * 
 */
const createRouter = () => new Router({
  // mode: 'history', // require service support
  //scrollBehavior: () => ({ y: 0 }),
  base: process.env.BASE_URL,
  routes: routes
})

const router = createRouter()


// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}


router.beforeEach(async (to, from, next) => {
  const requiresAuth = to.matched.some(x => x.meta.requiresAuth);
  const user = await firebase.getCurrentUser();
  if (user) store.dispatch('auth/autoSignIn', user);
  //console.log(store.getters['auth/user']);
  //console.log('----------------------');
  //console.log(user);
  //console.log('----------------------');
  //console.log('to:from = ' + from.name);
  //console.log('to:name = ' + to.name);
  //console.log('store.getters[auth/country] = ' + store.getters['auth/country']);
  if (requiresAuth && !user) {
    next({
      path: '/sign-in',
      query: { redirect: to.fullPath }
    });
  } else {
    if (
      (to.name == 'account-type' || to.name == 'organization-id' || to.name == 'sign-up') &&
      !store.getters['auth/country']
    ) {
      next('/select-country');
    } else {
      next();
    }
  }
});




export default router;
